import { render, staticRenderFns } from "./DatashareRevoke.vue?vue&type=template&id=7d625159&scoped=true&"
import script from "./DatashareRevoke.vue?vue&type=script&lang=js&"
export * from "./DatashareRevoke.vue?vue&type=script&lang=js&"
import style0 from "./DatashareRevoke.vue?vue&type=style&index=0&id=7d625159&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d625159",
  null
  
)

export default component.exports